import PageHeader from '../../../components/PageHeader';
import Sidebar from '../../../components/Sidebar';
import Transitions from '../../../components/Transition';
import VehicleForm from './components/VehicleForm';

export default function NewVehicle() {
  return (
    <>
      <Sidebar active="Vehicles" />
      <Transitions>
        <PageHeader
          title="Novo Veículo"
          link="/vehicles"
        />
        <VehicleForm />
      </Transitions>
    </>
  );
}
